import dayjs, { Dayjs } from 'dayjs';

export const dayjsWithTimezone = (...args: Parameters<typeof dayjs>): Dayjs => {
    return dayjs(...args).tz();
};
